import { useMemo } from "react";
import { useQuery } from "react-query";
import { getWrapNoteTypes } from "../../../api/services";
import { useAccount } from "../../../api/hooks";

export const useWrapUpNotes = (accountNumber?: string) => {
  const {
    isFetching: isFetchingTypes,
    data: types,
    error: typesError,
  } = useQuery("wrapNoteTypes", getWrapNoteTypes);

  const {
    isFetching: isFetchingAccount,
    data: accountDetails,
    error: accountDetailsError,
  } = useAccount(accountNumber);

  const errors = useMemo(() => {
    return [typesError, accountDetailsError].filter(
      (err) => err instanceof Error,
    );
  }, [typesError, accountDetailsError]);

  return {
    isFetching: isFetchingTypes || isFetchingAccount,
    errors,
    types,
    accountDetails,
  };
};
